import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Desk 95',
    description: 'A Windows 95 desktop holding ten archive documents: drag the files, open the folders, read the sheets.',
    url: getOrigin()
}